import { render, staticRenderFns } from "./NotificationPointListSection.vue?vue&type=template&id=3f750026&scoped=true"
import script from "./NotificationPointListSection.vue?vue&type=script&lang=ts"
export * from "./NotificationPointListSection.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPointListSection.vue?vue&type=style&index=0&id=3f750026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f750026",
  null
  
)

export default component.exports